<div class="db-website-creation-states">
  <!-- Install Package Step -->
  <ng-container *ngIf="step === 'install-package'">
    <div class="db-website-creation-install-package">
      <img src="assets/images/loading/spinner-dotted.svg" class="loader" alt="loader"/>
      <p>{{ 'text_settingUpProject' | dbText}}</p>
    </div>
  </ng-container>

  <!-- Regenerate Step -->
  <ng-container *ngIf="step === 'regenerate'">
    <div class="db-website-creation-regenerate">
      <h2>{{'text_generateBrandNew' | dbText}}</h2>
      <div class="desc-list">
        <div class="desc-list-item">
          <i class="db-icon db-icon-ds-checkmark-circle"></i>
          <span [innerHTML]="'text_regenerateDisclaimerCheckmark1' | dbText"></span>
        </div>
        <div class="desc-list-item">
          <i class="db-icon db-icon-ds-checkmark-circle"></i>
          <span [innerHTML]="'text_regenerateDisclaimerCheckmark2' | dbText"></span>
        </div>
        <div class="desc-list-item">
          <i class="db-icon db-icon-ds-checkmark-circle"></i>
          <span [innerHTML]="'text_regenerateDisclaimerCheckmark3' | dbText:{companyName}"></span>
        </div>
      </div>
      <div class="db-buttons-wrap">
        <button class="ds-btn-outline ds-btn-cancel m" (click)="close()"><span>{{'text_cancel' | dbText}}</span></button>
        <button class="ds-btn-black m" (click)="setStep('provide-description')"><span>{{'text_yesGenerate' | dbText}}</span></button>
      </div>
    </div>
  </ng-container>

  <!-- Provide Description Step -->
  <ng-container *ngIf="step === 'provide-description'">
    <div class="db-website-creation-provide-description">
      <db-website-prompt
        #websitePrompt
        [builderType]="builderType"
        [user]="user"
        [website]="website"
        [userSubscription]="userSubscription"
        (sendPrompt)="onPromptSend($event)">
      </db-website-prompt>
    </div>
  </ng-container>

  <!-- Remix Step -->
  <ng-container *ngIf="step === 'remix'">
    <div class="db-website-creation-install-package">
      <img src="assets/images/loading/spinner-dotted.svg" class="loader" alt="loader"/>
      <p>Creating your own copy of the project…</p>
    </div>
  </ng-container>

  <!-- Outline Step -->
  <ng-container *ngIf="step === 'outline'">
    <div class="db-website-creation-outline">
      <db-builder-v2
        #builderV2
        [domainId]="website?.id || websiteId"
        [website]="website"
        [user]="user"
        [userSubscription]="userSubscription"
        [popupMode]="true"
        [logo]="companyInfo?.branding?.cache_icon_big"
        [fromWebsiteCreationPrompt]="true"
        [builderType]="builderType"
        [triggerDescriptionFlow]="triggerDescriptionFlow"
        [isMobileAutoGenerate]="isMobileAutoGenerate"
        (buildComplete)="close()">
      </db-builder-v2>
    </div>
  </ng-container>
</div>

